/*
 * Public API Surface of ngx-text-decoration
 */

export * from './lib/ngx-text-decoration.module';
